(function() {
	var obs = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('vis');
			obs.unobserve(entry.target);
		});
	}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

	document.querySelectorAll('.ll-rv, .ll-rv-l, .ll-rv-r, .ll-rv-s').forEach(function(el) {
		obs.observe(el);
	});
})();
